import { InjectionToken } from '@angular/core';

import { WebSocketConfig } from './ws.interfaces';

/** Optional: an app that never provides it simply has no realtime. */
export const WEBSOCKET_CONFIG = new InjectionToken<WebSocketConfig>('WEBSOCKET_CONFIG');
